var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('vue-loading',{staticClass:"loading-element",attrs:{"type":"spiningDubbles","color":"rgb(90, 193, 221)","size":{ width: '80px', height: '80px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }